// Response object for POST /get
export interface ConfigProps {
  basic?: string;
  variables?: string;
  /**
   * FE-4451 — screen-template bodies, keyed by external_id: the same value a
   * component's `template` field carries. Folded in from the envelope root by
   * `normalizeAppData`; consumed by `expandTemplateRefs` at parse time.
   */
  templates?: Record<string, any>;
  public_url?: string;
  endpoint_id?: string;
  process_id?: string;
  endpoint_type?: string;
  task_ref?: string;
  urls?: {
    [key: string]: string;
  };
  style?: any;
  features?: {
    disable_sign_up: boolean;
    disable_node_screen: boolean;
    processes: boolean;
  };
}

export enum ConfigActionTypes {
  CONFIG_REQUEST = '@@config/CONFIG_REQUEST',
  CONFIG_EMPTY_REQUEST = '@@config/CONFIG_EMPTY_REQUEST',
  CONFIG_SUCCESS = '@@config/CONFIG_SUCCESS',
  CONFIG_ERROR = '@@config/CONFIG_ERROR',
  CONFIG_UPDATE_ENDPOINT_PARAMS = '@@config/CONFIG_UPDATE_ENDPOINT_PARAMS',
}

export interface EndpointParams {
  endpoint_id?: string;
  endpoint_type?: string;
  process_id?: string;
  task_ref?: string;
}

export interface ConfigState {
  readonly data: ConfigProps;
  readonly initializedFromInitScript?: boolean;
  readonly publicUrl?: string;
}
